import { useEffect, useState } from 'react';
import InfoSidebar from '../../../../../features/InfoSidebar/InfoSidebar';
import NotFound from '../../../../../features/NotFound/NotFoundPage';
import PackagesTable from './PackagesTable/PackagesTable';
import PricingTable from './PricingTable/PricingTable';
import ServicesTable from './ServicesTable';

function PackageInfoTitle({ title }) {
    return (
        <div className="py-2.5 px-5 bg-slate-300 rounded-10 mb-6">
            <h2 className="text-primary text-xl font-medium">{title || '--'}</h2>
        </div>
    );
}

function TabButton({ title, onClick, isActive }) {
    return (
        <button
            type="button"
            className={`text-xl font-medium ${
                isActive ? 'text-primary' : 'text-[rgba(4,43,58,0.30)]'
            }`}
            onClick={onClick}
        >
            {title}
        </button>
    );
}

function PackageInfo({ packageInfo, isSelected }) {
    const [tabIndex, setTabIndex] = useState(1);

    if (!isSelected) {
        return (
            <div className="mt-6">
                <NotFound
                    title="No Package Selected!"
                    btnTitle=""
                    evButtonClick={null}
                    className="h-full"
                />
            </div>
        );
    }
    return (
        <div className="w-full">
            <PackageInfoTitle title={packageInfo?.packageName} />
            <div className="flex gap-x-7 mb-4">
                <TabButton
                    title="Pricing"
                    onClick={() => setTabIndex(1)}
                    isActive={tabIndex === 1}
                />
                <TabButton
                    title="Services"
                    onClick={() => setTabIndex(2)}
                    isActive={tabIndex === 2}
                />
            </div>
            <PricingTable show={tabIndex === 1} />
            <ServicesTable show={tabIndex === 2} />
        </div>
    );
}

function PageTables({ productInfo, openModal, isSelected, isClicked, packageInfo }) {
    const [showMenu, setShowMenu] = useState(false);

    // if any package selected then show info sidebar
    useEffect(() => {
        if (isSelected) setShowMenu(true);
    }, [isSelected, isClicked]);

    if (productInfo && productInfo?.packages?.length === 0) {
        return (
            <div className="mt-16">
                <NotFound
                    title="No Package Found!"
                    btnTitle="Add Package"
                    evButtonClick={() => openModal('addPackage')}
                    className="h-full"
                />
            </div>
        );
    }
    return (
        <div className="flex gap-x-5 overflow-hidden">
            <div className="w-full overflow-hidden transition-all duration-[600ms] ease-in-out">
                <div className="mb-3">
                    <h2 className="text-primary text-xl font-medium">List Of Packages</h2>
                </div>
                <PackagesTable />
            </div>

            <InfoSidebar show={showMenu} setShow={setShowMenu} className="lg:w-[70%] xl:w-1/2">
                <PackageInfo packageInfo={packageInfo} isSelected={isSelected} />
            </InfoSidebar>
        </div>
    );
}

export default PageTables;
